export default "__VITE_ASSET__Bw2blse7__";